import api from "../../api"; 

const baseURL = process.env.REACT_APP_BASE_URL + "/county";

class CountyService {

    createCounty(county){
        return api.post(baseURL + "/save", county);
    }

    getCountyById(countyId){
        return api.get(baseURL + '/search?idNum=' + countyId);
    }    

    updateCounty(county){
        return api.post(baseURL, county);
    }

    deleteCounty(countyId){
        return api.post(baseURL + '/delete?countyCd=' + countyId);
    }

    deleteCountybyId(countyId){
        return api.post(baseURL + '/delete?idNum=' + countyId);
    }

    deleteBatchCounty(county){
        return api.post(baseURL + '/deleteall',  county);
    }
    
}

export default new CountyService()